<template>
  <div class="animated fadeIn">
    <div class="pre-scrollable  " style="max-height: 83vh; overflow-x: hidden;">
      <b-navbar :no-body="true" class="p-0 " fixed :sticky="true" toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand>
            <i class='px-3 fa fa-list-alt'></i><strong>  Pesquisa</strong> <small>Informe os dados</small>
        </b-navbar-brand>
        

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!--
              <b-button type="button" variant="secondary" @click="aguarde = true">Launch demo modal</b-button>
              -->
                
              <b-button class="px-2  "   type="button" variant="dark" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-question-circle"></i></span>
              </b-button>  
              
              <b-button class="px-2 f " type="reset"  variant="dark"  @click.stop.prevent="limpar()">
                <span style="font-size: 1.2rem" > <i  class="fa fa-ban"></i></span>
              </b-button>                            
              <b-button class="px-2  "  variant="dark" type="button"  > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-print"></i></span>
              </b-button>
              <b-button v-if="filtro.avancado === true" class="px-2  "  variant="dark" type="button"  @click.stop.prevent="filtro.avancado = false" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-sort-asc"></i></span>
              </b-button>
              <b-button v-else class="px-2  "  variant="dark" type="button" @click.stop.prevent="filtro.avancado = true" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-sort-desc"></i></span>
              </b-button>   
              <b-form-select class=" px-3 bg-gray-100"  style="font-size: 1.2rem" :options="[{text:20,value:20},{text:30,value:30},{text:50,value:50}, {text:100,value:100}]" v-model="perPage">
                </b-form-select>
              <!--<strong class="px-1 text-light">  De: </strong>-->
              <b-form-input  type="date" id="dt1" placeholder="Informe a data Inicio" v-model="dt1" 
                                class=" px-2 bg-gray-100" style="font-size: 1.2rem"> </b-form-input>
              <!--<strong class="px-2 text-light">  Até: </strong>-->
              <b-form-input  type="date" id="dt2" placeholder="Informe a data Término" v-model="dt2" 
                               class="px-2 bg-gray-100" style="font-size: 1.2rem">  <span  ></span> </b-form-input>      
              <b-button class="px-2 font-weight-bold" type="button" :disabled="isBusy"  variant="primary" @click.stop.prevent="pesquiasr()">
                <span style="font-size: 1.2rem" > <b-spinner v-if="isBusy" small ></b-spinner> <i v-else class="fa fa-search"></i></span>
              </b-button>
              <div class="border-left">                              
                <b-button class="px-4 font-weight-bold" variant="success" type="button" @click.stop.prevent="novo()" > 
                  <span style="font-size: 1.2rem" >Adicionar Novo  <i  class="fa fa-plus-square-o"></i></span>
                </b-button>
              </div>
              
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-card body-class="alert-dark" v-if="filtro.avancado === true">
          <b-row>
            <b-col sm="2">
              <b-form-group>
                <label for="codigo">Número do Pedido</label>
                <b-form-input type="text" id="pedido" placeholder="Opcional - número do Pedido" v-model="pedido"></b-form-input>
              </b-form-group>
            </b-col>
            <!--/.col-->
            <b-col sm="2">
              <b-form-group>
                <label for="codigo">Número de Controle</label>
                <b-form-input type="text" id="id" placeholder="Opcional - número de Controle" v-model="id"></b-form-input>
              </b-form-group>
            </b-col>
            <!--/.col-->
            <b-col sm="2">
              <b-form-group>
                <label for="codigo">Situação</label>
                  <b-form-select :plain="true"  v-model="tipoSituacao" :options="optionsSituacao">
                  </b-form-select>
              </b-form-group>
            </b-col>
            <!--/.col-->
            <b-col sm="6">
              <b-form-group>
                <cliente-pesquisa 
                                  @retornaId="clienteId = $event"
                                  :idInicial="clienteId"
                                  label="Cliente"
                                  place="Informe o Cliente"
                                  labelBotao=""
                                  ref="clientepesquisa"
                                  idModal="clientepesquisa">
                </cliente-pesquisa>
              </b-form-group>
            </b-col>
          </b-row>
        
      </b-card>
    
      <!--/.row-->
      <b-row >
        <b-col sm="12">
          <b-card>
              
            <!-- Main table element -->
            
    
            <b-table class="table table-sm"
                    show-empty
                    empty-text="Informe o filtro para ver os pesquisas "
                    stacked="md"
                    small
                    responsive 
                    :tbody-tr-class="rowClass"
                    striped 
                    hover 
                    :busy.sync="isBusy" 
                    :items="lista" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    select-mode="single"
                    selectable
                    @row-selected="edit"
                    >
              <template #cell(SITUACAO)="item">
                <b-badge pill :variant="colorirStatus(item.item.SITUACAO)">{{traduzirSituacao(item.item.SITUACAO)}}</b-badge>
              </template>      
              <template #cell(OP_FORMA_PAGTO)="item">
                <b-badge pill :variant="colorirFormaPagto(item.item.OP_FORMA_PAGTO)">{{traduzirFormaPagto(item.item.OP_FORMA_PAGTO)}}</b-badge>
              </template>      
              <template #cell(actions)="item">
                <!--
                <b-button type="button" @click.stop.prevent="edit(item.item)"  size="sm" variant="primary" >
                  <i class="fa fa-folder-open-o"></i>
                </b-button>
                -->
                <b-button  type="button" @click="abrirModalInfo(item.item)" size="sm" variant="info" title="Mais Detalhes" v-b-tooltip.hover.left >
                  
                  <i class="fa fa-info"></i>
                </b-button>
                <b-button v-if="item.item.SITUACAO === '1' || item.item.SITUACAO === '2'"  type="button" @click="abrirModalCancelamento(item.item)" size="sm" variant="danger" title="Cancelar Titulo" v-b-tooltip.hover.left>
                  <i class="fa fa-close"></i>
                </b-button>
                <b-button v-if="item.item.SITUACAO != '2'"  type="button" @click.stop.prevent="imprimir(item.item.SEQUENCIA)" size="sm" variant="warning" title="Re-imprimir" v-b-tooltip.hover.left>
                  
                  <i class="fa fa-print"></i>
                </b-button>
                <b-button v-if="item.item.OP_PDF_ONLINE === '1'" type="button" @click="downloadPDFNfe(item.item)" size="sm" variant="secondary" title="Nota Fiscal" v-b-tooltip.hover.left>
                  <i class="fa fa-file-pdf-o"></i>
                </b-button>

              </template>
            </b-table>
            
            <div class="justify-content-center row my-1">
              <b-pagination size="md" :total-rows="this.lista.length" :per-page="perPage" v-model="currentPage" />
            </div>
            <h1>{{user}}</h1>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL CANCELAMENTO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-cancelamento" 
          id="modal-cancelamento" 
          hide-header
          body-class="p-0"
          size="lg"
          @shown="focusModalCancelamento()" 
          headerClass= "p-2 border-bottom-0" 
          title="CANCELAR PEDIDO" >
        <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                    no-wrap 
                    fixed 
                    z-index="1100" 
                    spinner-variant="primary"
                    spinner-type="border">
          <template #overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p>Por favor. Aguarde!!!...</p>
            </div>
          </template>
        </b-overlay>
        <b-card bg-variant="light">
            <div slot="header">
                <i class='fa fa-align-justify'></i><strong>  Cancelar Pedido</strong>
            </div>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Cliente:</label>
              </b-col>
              <b-col cols="12" md="8">
                <strong>{{cancelamento.dados.nomeCliente}}</strong>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Pedido:</label>
              </b-col>
              <b-col cols="12" md="3">
                <strong>{{cancelamento.dados.documento}} - {{cancelamento.dados.parcela}}</strong>
              </b-col>
              <b-col cols="12" md="3">
                <label>Data Vencimento:</label>
              </b-col>
              <b-col cols="12" md="3">
                <strong>{{cancelamento.dados.dataVencimento}}</strong>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Valor:</label>
              </b-col>
              <b-col cols="12" md="3">
                <strong>{{cancelamento.dados.valorDocumento}}</strong>
              </b-col>
            </b-row>
            <hr>
            <b-row v-if="cancelamento.parametros.permissao === false" class="mb-1">
              <b-col cols="12" md="12" class="text-center p-3">
                <label class="text-danger"><strong>USUARIO SEM PERMISSÃO PARA CANCELAR!!!!</strong> </label>
              </b-col>
            </b-row>
            <b-row v-if="cancelamento.parametros.permissao === true" class="mb-1">
              <b-col cols="12" md="3">
                  <label for="motivoCancelamento">Motivo do Cancelamento</label>
              </b-col>
              <b-col cols="12" md="8">
                  <b-form-input type="text" ref="motivoCancelamento" id="motivoCancelamento" v-model="cancelamento.dados.motivo" 
                                :state="valMotivoCancelamento"
                                placeholder="Preencher o Motivo do Cancelamento" ></b-form-input>
              </b-col>
            </b-row>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button v-if="cancelamento.parametros.permissao === true" variant="success" @click="cancelar()">
            CONFIRMAR CANCELAMENTO
          </b-button>
          <b-button    variant="danger" @click="cancel()">
            Fechar
          </b-button>
        </template>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                            MODAL INFO 
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-info" 
          id="modal-info" 
          hide-header
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="DETALHES DA PEDIDO" >
        
        <b-card bg-variant="light">
          <div slot="header">
              <i class='fa fa-info'></i><strong>  ITENS DA PEDIDO</strong>
          </div>
          <b-row class="mb-1">
            <b-col cols="2">
              <label>Controle ID:</label>
            </b-col>
            <b-col cols="2">
              <strong>{{dadosModalInfo.id}}</strong>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="2">
              <label>Cliente:</label>
            </b-col>
            <b-col cols="4">
              <strong>{{dadosModalInfo.nomeCliente}}</strong>
            </b-col>
            <b-col cols="2">
              <label>Vendedor:</label>
            </b-col>
            <b-col cols="4">
              <strong>{{dadosModalInfo.nomeVendedor}}</strong>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="2">
              <label>Pedido:</label>
            </b-col>
            <b-col cols="2">
              <strong>{{dadosModalInfo.documento}}</strong>
            </b-col>
            <b-col cols="2">
              <label>Data:</label>
            </b-col>
            <b-col cols="2">
              <strong>{{dadosModalInfo.dataVenda}}</strong>
            </b-col>
            <b-col cols="2">
              <label>Valor:</label>
            </b-col>
            <b-col cols="2">
              <strong>{{dadosModalInfo.total}}</strong>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <strong>DADOS ALTERAÇÃO</strong>
          </b-row>
          <b-row>
            <b-col sm="2">
                Data
            </b-col>
            <b-col sm="2">
                <strong>{{dadosModalInfo.dataAlteracao}}</strong>
            </b-col>
            <b-col sm="2">
                Usuario 
            </b-col>
            <b-col sm="2">
                <strong>{{dadosModalInfo.usuarioAlteracao}}</strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
                Motivo
            </b-col>
            <b-col sm="10">
                <strong>{{dadosModalInfo.motivoAlteracao}}</strong>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <strong>DADOS CANCELAMENTO</strong>
          </b-row>
          <b-row>
            <b-col sm="2">
                Data
            </b-col>
            <b-col sm="2">
                <strong>{{dadosModalInfo.dataCancelamento}}</strong>
            </b-col>
            <b-col sm="2">
                Usuario 
            </b-col>
            <b-col sm="2">
                <strong>{{dadosModalInfo.usuarioCancelamento}}</strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
                Motivo
            </b-col>
            <b-col sm="10">
                <strong>{{dadosModalInfo.motivoCancelamento}}</strong>
            </b-col>
          </b-row>
          <hr>
          <b-table 
            striped 
            hover 
            show-empty
            empty-text="Pedido sem Produtos lançados "
            stacked="md"
            small
            responsive 
            select-mode="single"
            head-variant="dark"
            selectable
            :items="tabelaItens.items" 
            :fields="tabelaItens.fields">
          </b-table>
        </b-card>
        <template #modal-footer="{ cancel }">
          <b-button    variant="danger" @click="cancel()">
            Fechar
          </b-button>
        </template>
      </b-modal>
    </div>

  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import moment from 'moment'

export default {
  data () {
    return {
      filtro: {
        avancado: false
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      dadosModalInfo: {
        id: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        usuarioAlteracao: null,
        dataAlteracao: null,
        motivoAlteracao: null,
        usuarioCancelamento: null,
        dataCancelamento: null,
        motivoCancelamento: null,
        total: 0.00

      },
      tabelaItens: {
        fields: [
          {
            key: "CODIGO_NOME_PRODUTO",
            label: 'Produto'
          },
          {
            key: "QUANT",
            label: 'Quantidade',
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS",
            label: 'Peças'
          },
          {
            key: "TX_UNIDADE_COMERCIAL",
            label: 'UND'
          },
          {
            key: 'VL_UNT', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_DESCONTO', 
            class:'text-right', 
            label: 'Desconto (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_TOTAL_BRUTO', 
            class:'text-right', 
            label: 'Total (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          }
        ],
        items: []
      },
      optionsSituacao: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'Cancelado' },
        { value: '1', text: 'Fechado' },
        { value: '2', text: 'Aberto' }
      ],
      status: '',
      isBusy: false,
      fields: [
        {
          key: "SEQUENCIA",
          label: 'Id',
          sortable: true
        },
        {
          key: "N_VENDA",
          label: 'Pedido', 
          sortable: true 
        },
        {
          key: "SITUACAO",
          label: 'Situação',
          sortable: true 
        },
        {
          key: "OP_FORMA_PAGTO",
          label: 'Pagamento',
          sortable: true 
        },
        {
          key: "NOME_CLIENTE",
          label: 'Nome do Cliente',
          sortable: true 
        },
        {
          key: "DT_PEDIDO",
          label: 'Data Pedido', 
          sortable: true,
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: "ORDEM_EXPEDICAO_ID",
          label: 'Ordem Exp.', 
          sortable: true 
        },
        {
          key: "NOME_VENDEDOR",
          label: 'Vendedor', 
          sortable: true 
        },
        {
          key: 'VL_TOTAL_NFE', 
          class:'text-right', 
          label: 'Total (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null
        },
        {
          key: "actions" ,
          label: 'Ações',
           class:'text-right',
           thStyle: { width: "12%" }
        }
      ],
      currentPage: 1,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      
      columns: [
        {title: 'ID', dataKey: 'id'},
        {title: 'Name', dataKey: 'name'},
        {title: 'Country', dataKey: 'country'}
      ],
      rows: [
        {'id': 1, 'name': 'Shaw', 'country': 'Tanzania'},
        {'id': 2, 'name': 'Nelson', 'country': 'Kazakhstan'},
        {'id': 3, 'name': 'Garcia', 'country': 'Madagascar'}
      ]
    }
  },
  components: {
    VueButtonSpinner,
    ClientePesquisa
  },
  computed: {
    valMotivoCancelamento() {
      return ((this.cancelamento.dados.motivo ) && (this.cancelamento.dados.motivo != '')) ? true : false 
    },
    user () {
      return '' // this.$store.state.dadosSessao.nome
    },
    dt1: {
      get () {
        return this.$store.getters['vendaPedido/DT1']
      }, 
      set (value) {
        this.$store.commit("vendaPedido/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['vendaPedido/DT2']
      }, 
      set (value) {
        this.$store.commit("vendaPedido/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['vendaPedido/ID']
      }, 
      set (value) {
        this.$store.commit("vendaPedido/SET_ID", value);
      }
    },
    pedido: {
      get () {
        return this.$store.getters['vendaPedido/PEDIDO']
      }, 
      set (value) {
        this.$store.commit("vendaPedido/SET_PEDIDO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['vendaPedido/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("vendaPedido/SET_CLIENTE_ID", value)
      }
    },
    tipoSituacao: {
      get () {
        return this.$store.getters['vendaPedido/TIPO_SITUACAO']
      }, 
      set (value) {
        this.$store.commit("vendaPedido/SET_TIPO_SITUACAO", value)
      }
    },
    lista: {
      get () {
        return this.$store.getters['vendaPedido/LISTA']
      }, 
      set (value) {
        this.$store.commit("vendaPedido/SET_LISTA", value)
      }
    }
  },
  methods: {
    cancelar() {
      if (!this.valMotivoCancelamento) {
        this.toastCount++
        this.$root.$bvToast.toast('Informe o motivo!', {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      this.$store.commit('controle/setAguardando', true)
      this.$http.get( `/api/protected/vendapedido/getById/${this.cancelamento.dados.id}`)
      .then(result => {
        if (result.data) {
          result.data[0].TX_USUARIO_CANCELAMENTO = this.cancelamento.dados.usuario
          result.data[0].MOT_CANC = this.cancelamento.dados.motivo
          return  this.$http.post(`/api/protected/vendapedido/delete`, result.data[0] )
        } else {
          return Promise.reject('Não foi possível consultar a venda')
        }
      })
      .then(() =>{
        return this.$store.dispatch('vendaPedido/GERAR_LISTA')
      })
      .then(() => {
        this.toastCount++
        this.$root.$bvToast.toast('Atualização da venda realizado com Sucesso!', {
          title: 'Sucesso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        this.$refs['modal-cancelamento'].hide()
        this.$store.commit('controle/setAguardando', false)
      })
      .catch(err => {
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++

        let msg 
        if (err.response && err.response.status) {
          msg = err.response.data
          this.$root.$bvToast.toast(msg, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        } else {
          this.$root.$bvToast.toast(`Não foi possivel validar as permissões. \nEntre em contato com o administrador do sistema !! ${err}`, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        }
      })

      
    },
    abrirModalInfo(item) {

      this.$store.commit('controle/setAguardando', true)
      this.tabelaItens.items = null
      this.dadosModalInfo.id = null
      this.dadosModalInfo.documento = null
      this.dadosModalInfo.dataVenda = null
      this.dadosModalInfo.nomeCliente = null
      this.dadosModalInfo.nomeVendedor = null
      this.dadosModalInfo.total = null
      
      this.dadosModalInfo.usuarioAlteracao = null
      this.dadosModalInfo.dataAlteracao = null
      this.dadosModalInfo.motivoAlteracao = null
      this.dadosModalInfo.usuarioCancelamento = null
      this.dadosModalInfo.dataCancelamento = null
      this.dadosModalInfo.motivoCancelamento = null
      
      this.$http.get('/api/protected/venda/item/getListagemByVenda/'+item.SEQUENCIA)
      .then((response) => {
        this.tabelaItens.items = response.data
        this.dadosModalInfo.id = item.SEQUENCIA
        this.dadosModalInfo.documento = item.N_VENDA
        this.dadosModalInfo.dataVenda = item.DT_PEDIDO ? moment(String(item.DT_PEDIDO)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.nomeCliente = item.NOME_CLIENTE
        this.dadosModalInfo.nomeVendedor = item.NOME_VENDEDOR
        this.dadosModalInfo.total = item.VL_TOTAL_NFE ? item.VL_TOTAL_NFE.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
        
        this.dadosModalInfo.usuarioAlteracao = item.TX_USUARIO_ALTERACAO
        this.dadosModalInfo.dataAlteracao = item.DT_ALTERACAO ? moment(String(item.DT_ALTERACAO)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.motivoAlteracao = item.OBS3
        this.dadosModalInfo.usuarioCancelamento = item.TX_USUARIO_CANCELAMENTO
        this.dadosModalInfo.dataCancelamento = item.DT_CANC ? moment(String(item.DT_CANC)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.motivoCancelamento = item.MOT_CANC

        this.$refs['modal-info'].show()
        this.$store.commit('controle/setAguardando', false)
      })
    },
    async abrirModalCancelamento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        const result = await this.$http.get(`api/protected/vendaPedido/getPermiteAlterar/${item.SEQUENCIA}`)
        const permite = result.data?.permite ?? false
        if (permite == false) {
          Tools.exibirMensagem('A situação do Pedido não permite cancelamento!.', 'warning')
          return
        }

        this.cancelamento.dados.titulo = item.N_VENDA
        this.cancelamento.dados.id = item.SEQUENCIA
        this.cancelamento.dados.nomeCliente = item.NOME_CLIENTE
        this.cancelamento.dados.documento = item.N_VENDA
        this.cancelamento.dados.motivo = ''
        this.cancelamento.dados.dataVencimento = moment(String(item.DT_PEDIDO)).format('DD/MM/YYYY')
        this.cancelamento.dados.valorDocumento = item.VL_TOTAL_NFE ? item.VL_TOTAL_NFE.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
        this.cancelamento.dados.usuario = window.localStorage.getItem('login')

        //venda Aberta
        if (this.lista.SITUACAO === '2') {
            this.cancelamento.parametros.permissao = true
            this.cancelamento.parametros.processando = false
            this.cancelamento.parametros.busy = true
            this.$refs['modal-cancelamento'].show()
            return
        }

        //Venda fecahda

        const permissaoPayLoad = {
          login: window.localStorage.getItem('login'),
          permissao: 'AcPropExcluirVendas'
        }

        try {
          const {data} = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
          if (!data || data.permissao == false) {
            this.estorno.parametros.permissao = false
            Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário não autorizado')
            return
          }
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }
        
        this.cancelamento.parametros.permissao = true
        this.cancelamento.parametros.processando = false
        this.cancelamento.parametros.busy = true
        this.$refs['modal-cancelamento'].show()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async downloadPDFNfe (item) {
      this.$store.commit('controle/setAguardando', true)
      let uri = `/api/protected/notaFiscal/downloadPDFVendaId/${item.SEQUENCIA}`
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Nota Fiscal Eletronica.pdf') 
          link.download = 'NFe.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Nota Fiscal Eletronica'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(async error => {
          this.$store.commit('controle/setAguardando', false)
          //if (erro.response.status == 400) {
            //console.log(error.response.data)
            //const blob = new Blob([JSON.stringify(error.response.data)])

            var textdata = ''
            if (error.response.request.responseType === 'arraybuffer'
              && error.response.data.toString() === '[object ArrayBuffer]'
            ) {
              var buffer = new Buffer(error.response.data, 'binary')
              textdata = buffer.toString()
            } else {
              textdata = erro.response.data
            }
            
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${textdata}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          //}
        })
    },
    focusModalCancelamento() {
      this.$refs.motivoCancelamento.focus()
    },
    limpar() {
      this.$store.commit("vendaPedido/SET_LIMPAR", null)
    },
    rowClass(item, type) {
      if (item && type === 'row') {
        if ((item.SITUACAO_TRADUZIDO) && (item.SITUACAO_TRADUZIDO.trim() === 'CANCELADO')) {
          return 'text-danger'
        } else {
          return null
        } 
      } else {
        return null
      }
    },
    colorirFormaPagto(valor) {
      if (valor == 'V') return 'info'
      else if (valor == 'P') return 'secondary'
      else 'warning'
    },
    traduzirFormaPagto(valor) {
      if (valor === 'V') return 'A VISTA'
      else if (valor === 'P') return 'A PRAZO'
      else ''
    },
    colorirStatus(valor) {
      if (valor == '0') return 'danger'
      else if (valor == '1') return 'success'
       else if (valor == '2') return 'warning'
        else if (valor == '3') return 'info'
      else 'info'
    },
    traduzirSituacao (value) {
      let $variant
      if ( value == '0'  ) {
        $variant = 'CANCELADO'
      } else if ( value == '1'  ) {
        $variant = 'FATURADO'
      } else if ( value == '2'  ) {
        $variant = 'EM CADASTRO'
      } else if ( value == '3'  ) {
        $variant = 'AGUARDANDO'
      } else if ( value == '4'  ) {
        $variant = 'ORDEM EXPEDIÇÃO'
      } else if ( value == '5'  ) {
        $variant = 'EMBARCANDO'
      } else if ( value == '6'  ) {
        $variant = 'EMBARCADO'
      }
      return $variant
    },
    details (item) {
      alert(JSON.stringify(item.item.SEQUENCIA))
    },
    edit (item) {
      this.$store.commit('controle/setAguardando', true)
      this.$router.push(`/movimentos/pedidovenda/edit/${item[0].SEQUENCIA}`)
    },
    novo () {
      this.$router.push(`/movimentos/pedidovenda/add`)
    },
    pesquiasr (ctx) {
      this.$store.commit('controle/setAguardando', true)
      this.$store
      .dispatch('vendaPedido/GERAR_LISTA')
      .then((data) => {
        this.$store.commit('controle/setAguardando', false)
        this.status = true // or success
        return
      }).catch((error) => {
        if (error) {
          this.status = false // or error
        }
      })
    },
    imprimir (id) {
      this.$store.commit('controle/setAguardando', true)
      let uri = '/api/protected/relatorios/relvenda?id=' + id
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relVenda.pdf') 
          link.download = 'relVenda.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Vendas'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
        })
    }
  },
  created () {
    
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/movimentos/pedidovenda/PedidoVendaListagem.vue